import { REACT_APP_API_HOST as API_HOST } from 'envs';
import { axiosMockInstance } from './axios-mock-instance';

axiosMockInstance.onGet(API_HOST + '/profile').reply(200, {
	name: 'happy',
});
